import { render, staticRenderFns } from "./cModalDetalleReserva.vue?vue&type=template&id=68a4fa7b&scoped=true"
import script from "./cModalDetalleReserva.vue?vue&type=script&lang=js"
export * from "./cModalDetalleReserva.vue?vue&type=script&lang=js"
import style0 from "./cModalDetalleReserva.vue?vue&type=style&index=0&id=68a4fa7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a4fa7b",
  null
  
)

export default component.exports